<template>

  <header-app back="true" titlepage="اسکن بلیت"></header-app>
  <v-main class="main" >
    <qrcode-stream @detect="onDetect"></qrcode-stream>
  </v-main>
  <footer-app selectedItem="1"></footer-app>
</template>

<script >
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'
import HeaderApp from "@/views/headerApp.vue";
import FooterApp from "@/views/FooterApp.vue";
import DataView from "@/views/DataView.vue";

export default {
  name: 'qr-scaner',
  components:{
    QrcodeStream,
    HeaderApp,
    FooterApp,
    DataView,
  },
  data() {
    return {
      isValid: undefined,
      paused: false,
      result: null
    }
  },
  computed: {

  },

  methods: {
    onDetect (detectedCodes) {

      let result;
      result = JSON.stringify(detectedCodes.map((code) => code.rawValue))
      alert(result)
    },
  }
}
</script>

<style scoped>

</style>